import { z } from "zod";
import { InvoiceSchema } from "../../../models/invoice/invoice";

export const getAllInvoicesSchema = z.object({
    count: z.number(),
    next: z.string().nullable(),
    previous: z.string().nullable(),
    results: z.array(InvoiceSchema)
})

export type GetAllInvoicesSchemaType = z.infer<typeof getAllInvoicesSchema>;